import React from 'react';
import {Input, Row, Spin, Popconfirm, Pagination, Progress, message, Card, Col, Tree, Timeline, Icon, Form} from 'antd';
import {asyncList, actions, asyncTimeLineList} from './reducers';
import {connect} from 'react-redux';
import SearchForm from './search.js';
import Edit from './edit.js';

const TreeNode = Tree.TreeNode;


const dataList = [];
const generateList = (data) => {
    for (let i = 0; i < data.length; i++) {
        const node = data[i];
        const key = node.trackFinished === 3 ? node.key + '-error' : node.key;
        dataList.push({key, title: key});
        if (node.children) {
            generateList(node.children, node.key);
        }
    }
};

const getParentKey = (key, tree) => {
    if (key.indexOf("-error") != -1) {
        key = key.substr(0, key.indexOf("-error"));
    }
    let parentKey;
    for (let i = 0; i < tree.length; i++) {
        const node = tree[i];
        if (node.children) {
            if (node.children.some(item => item.key === key)) {
                parentKey = node.key;
            } else if (getParentKey(key, node.children)) {
                parentKey = getParentKey(key, node.children);
            }
        }
    }
    return parentKey;
};

class LogCollect extends React.Component {

    state = {
        expandedKeys: [],
        searchTreeValue: '',
        autoExpandParent: true,
        selectedRowKeys: [],
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.asyncList();
    }


    // 编辑
    edit = record => {
        this.props.setFilterData(record);
        this.props.editShow();
    }


    // 搜索树
    onTreeSearchChange = (e, list) => {
        const value = e.target.value;
        const expandedKeys = dataList.map((item) => {
            if (item.key.indexOf(value) > -1) {
                return getParentKey(item.key, list);
            }
            return null;
        }).filter((item, i, self) => item && self.indexOf(item) === i);
        this.setState({
            expandedKeys,
            searchTreeValue: value,
            autoExpandParent: true,
        });
    }

    // 树拓展
    onTreeExpand = (expandedKeys) => {
        this.setState({
            expandedKeys,
            autoExpandParent: false,
        });
    }

    // 点击树
    onTreeSelect = (selectedKeys, e) => {
        let id = selectedKeys[0];
        if (id != undefined && Number(id).toString() === "NaN") {
            if (id.indexOf("-error") != -1) {
                id = id.substr(0, id.indexOf("-error"));
            }
            this.props.changeCurrentUuid(id);
            this.props.asyncTimeLineList(id);
        }
    }

    render() {
        let {list, uiStatus, timeLineData, searchValue} = this.props;
        const {searchTreeValue, expandedKeys, autoExpandParent} = this.state;

        let {isLoading} = uiStatus;

        const rowSelection = {
            onChange: this.onSelectChange,
        };

        generateList(list);

        // 生成树
        const generateTree = data => data.map((item) => {

            const key = item.trackFinished === 3 ? item.key + '-error' : item.key;
            const index = key.indexOf(searchTreeValue);
            const beforeStr = key.substr(0, index);
            const afterStr = key.substr(index + searchTreeValue.length);
            const title = index > -1 ? (
                    <span>{beforeStr}<span style={{color: '#00ccff'}}>{searchTreeValue}</span>{afterStr}</span>)
                : <span>{key}</span>;

            let color = 'black';
            if (item.trackFinished === 3) {
                color = 'red';
            } else if (item.trackFinished === 1) {
                color = '#68c20a';
            }

            if (item.children) {
                return (
                    <TreeNode key={key} title={title}>
                        {generateTree(item.children)}
                    </TreeNode>
                );
            }
            return <TreeNode key={key} title={<span style={{color: color}}> {title} </span>}/>;
        });

        // 生成时间轴
        const generateTimeLine = data => data.map((item) => {

            if (item.code == 200) {
                return <Timeline.Item><span
                    onClick={() => {
                        this.edit(item)
                    }}><b>{item.name}</b>  <font
                    color={'green'}>{item.ip} </font> {item.startTime} {item.time}ms {item.msg} </span></Timeline.Item>;
            } else {
                let errorInfo = item.errorInfo;
                if (errorInfo.length > 100) {
                    errorInfo = errorInfo.substr(0, 100) + "..."
                }
                return <Timeline.Item dot={<Icon type="close" style={{fontSize: '16px'}}/>} color={'red'}><span
                    onClick={() => {
                        this.edit(item)
                    }}><font
                    color={'red'}><b>{item.name}</b> {item.ip} {item.startTime} {item.time}ms {item.msg} {errorInfo}</font>  </span></Timeline.Item>;
            }
        });

        const handleTitle = (timeLineData) => {
            let size = " ";
            let time = " ";
            if (timeLineData.length > 0) {
                size = timeLineData.length + "步";
                time = timeLineData[timeLineData.length - 1].speedTime;
                if (time > 1000) {
                    if (time > 60000) {
                        let min = parseInt(time / 60000);
                        let s = parseInt(time % 60000 / 1000);
                        // let ms = parseInt(time % 60000 % 1000);
                        if (s === 0) {
                            time = min + "min ";
                        } else {
                            time = min + "min " + s + "s ";
                        }

                    } else {
                        let s = parseInt(time / 1000);
                        // let ms = parseInt(time % 1000);
                        time = s + "s ";
                    }
                } else {
                    // 需求小于1s，展示为空
                    time = " ";
                }
            }

            return "执行情况  [ " + this.props.currentUuid + "  ] 共执行 [ " + size + " ] 共耗时 [ " + time + " ]";
        }

        return (
            <div style={{marginBottom: '20px'}}>
                <Row style={{marginTop: '10px'}}>
                    <SearchForm {...this.props} />
                </Row>
                <Spin spinning={isLoading} tip="加载中...">
                    <Row gutter={16}>
                        <Col span={7}>
                            <Card>
                                <Input.Search style={{marginBottom: 8}} placeholder="前端搜索"
                                              onChange={(e) => this.onTreeSearchChange(e, list)}/>
                                <div style={{overflowY: 'auto', height: '511', overflowX: 'auto'}}>
                                    {list.length > 0 &&
                                    <Tree
                                        defaultExpandAll={true}
                                        onExpand={this.onTreeExpand}
                                        expandedKeys={expandedKeys}
                                        autoExpandParent={autoExpandParent}
                                        onSelect={this.onTreeSelect}
                                        filterTreeNode={true}
                                    >
                                        {generateTree(list)}
                                    </Tree>}
                                </div>
                            </Card>
                        </Col>

                        <Col span={17}>
                            <Card
                                title={handleTitle(timeLineData)}>
                                <div style={{overflowY: 'auto', height: '500'}}>
                                    <Timeline>
                                        {generateTimeLine(timeLineData)}
                                    </Timeline>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                    <Edit/>
                </Spin>
            </div>
        );
    }

}

const mapStateToProps = state => ({
    list: state.logCollect.list,
    uiStatus: state.logCollect.uiStatus,
    filterData: state.logCollect.filterData,
    currentUuid: state.logCollect.currentUuid,
    timeLineData: state.logCollect.timeLineData,
});

const mapDispatchToProps = dispatch => ({
    asyncList: () => dispatch(asyncList()),
    editShow: () => dispatch(actions.changeUiStatus({isUpdateShow: true})),
    setFilterData: data => dispatch(actions.filterList(data)),
    changeCurrentUuid: uuid => dispatch(actions.changeCurrentUuid(uuid)),
    asyncTimeLineList: uuid => dispatch(asyncTimeLineList(uuid)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LogCollect);





// WEBPACK FOOTER //
// ./pages/assist/logCollect/index.js